import {Component, OnInit, ViewChild} from "@angular/core";
import {Auth2Service} from "../../../../services/auth2.service";
import {ApiService} from "../../../../services/api.service";
import {UserService} from "../../services/users.service";
import {Router} from "@angular/router";
import {HttpErrorResponse} from "@angular/common/http";
import {
  StPagination2Component
} from "../../../../shared-components/ui-components/st-pagination/st-pagination2.component";
import {PageChangeDto} from "../../../../models/page-change-dto";
import {LoggedInPageBaseComponent} from "../../../../shared-components/ui-components/logged-in-page-base/logged-in-page-base.component";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-saved-searches-container',
  templateUrl: './saved-searches-container.component.html',
  styleUrls: ['./saved-searches-container.component.scss'],
  standalone: false
})
export class SavedSearchesContainerComponent extends LoggedInPageBaseComponent implements OnInit {

  breadCrumbs = [
    { iconClass: 'bi-house', path: 'app/users/dashboard'},
    { label: 'Dashboard', path: 'app/users/dashboard'},
    { label: 'Your Saved Searches'}
  ];

  protected readonly event = event;

  savedSearches: any[] = [];

  searchTypeName = 'DONOR_SEARCH';
  searchTypeRoute: string = 'donor';

  saveSearchTypeRouteMap: any = {
    "DONOR_SEARCH": "donor",
    "GRANT_SEARCH": "grant",
    "NONPROFIT_SEARCH": "nonprofit"
  }

  firstLoad: boolean = true;

  username = '';
  impersonatedEmail: any = null;
  consultantRoleName: any = null;

  donorTabButtonFlag: boolean = true;
  grantTabButtonFlag: boolean = false;
  nonprofitTabButtonFlag: boolean = false;

  @ViewChild('savedsearchnonprofitspaginator') stPaginator2ComponentNonprofits!: StPagination2Component;
  nonprofit_collectionSize: number = 0;
  nonprofit_page: number = 1;
  nonprofit_pageSize: number = 5;

  @ViewChild('savedsearchdonorspaginator') stPaginator2ComponentDonors!: StPagination2Component;
  donor_collectionSize: number = 0;
  donor_page: number = 1;
  donor_pageSize: number = 5;

  @ViewChild('savedsearchgrantspaginator') stPaginator2ComponentGrants!: StPagination2Component;
  grant_collectionSize: number = 0;
  grant_page: number = 1;
  grant_pageSize: number = 5;

  customPageSizes = [
    {
      "pageSizeId" : 5,
      "pageSize": 5
    }, {
      "pageSizeId" : 10,
      "pageSize": 10
    }, {
      "pageSizeId" : 25,
      "pageSize": 25
    }, {
      "pageSizeId" : 50,
      "pageSize": 50
    }
  ];

  constructor(private auth2ServiceChild: Auth2Service, private apiService: ApiService, private userService : UserService,
              private routerChild: Router, private titleService: Title) {
    super(auth2ServiceChild, routerChild);

    this.titleService.setTitle("Scalanthropy All Saved Searches");
    this.username = this.auth2ServiceChild.getUsername();
    this.impersonatedEmail = this.auth2ServiceChild.getImpersonatedEmail();
    this.consultantRoleName = this.auth2ServiceChild.getConsultantRoleName();
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }

  getAllSavedSearchTabPages(username: string, searchTypeName: string, page: number, pageSize: number): void {

    this.userService.getAllSavedSearchesPages(this.username, this.searchTypeName, page, pageSize,
      this.impersonatedEmail).subscribe(
      (result: any) => {
        if (result && result.body) {
          this.savedSearches = result.body.dtos;
          if (this.searchTypeName == 'DONOR_SEARCH') {
            this.donor_collectionSize = result.body.collectionSize;
            this.donor_page = result.body.page;
            this.donor_pageSize = result.body.pageSize;
            if (this.donor_page == 1) {
              this.stPaginator2ComponentDonors.initPages(this.donor_collectionSize, this.donor_pageSize);
              if (this.firstLoad) {
                this.openSearchTypeList(event, 'DONOR_SEARCH', 'donor')
                this.firstLoad = false;
              }
            }
          } else if (this.searchTypeName == 'GRANT_SEARCH') {
            this.grant_collectionSize = result.body.collectionSize;
            this.grant_page = result.body.page;
            this.grant_pageSize = result.body.pageSize;
            if (this.grant_page == 1) {
              this.stPaginator2ComponentGrants.initPages(this.grant_collectionSize, this.grant_pageSize);
            }
          } else if (this.searchTypeName == 'NONPROFIT_SEARCH') {
            this.nonprofit_collectionSize = result.body.collectionSize;
            this.nonprofit_page = result.body.page;
            this.nonprofit_pageSize = result.body.pageSize;
            if (this.nonprofit_page == 1) {
              this.stPaginator2ComponentNonprofits.initPages(this.nonprofit_collectionSize, this.nonprofit_pageSize);
            }
          }
        }
      },
      (err: HttpErrorResponse) => {
        this.redirectToLogin(err);
        this.pageErrorMessages.push({
          field: 'Get Saved Searches API Failure',
          detail: 'Failed to pull saved searches...',
          severity: 'error'
        });
        this.showErrorMessagesToUser();
      }
    )
  }

  decideLoad(pageChangeDto: PageChangeDto): void {
    if (this.searchTypeName == 'DONOR_SEARCH') {
      this.donor_page = pageChangeDto["page"];
      this.donor_pageSize = pageChangeDto["pageSize"];
      this.getAllSavedSearchTabPages(this.username, this.searchTypeName, this.donor_page, this.donor_pageSize);
      this.donorTabButtonFlag = true;
      this.grantTabButtonFlag = false;
      this.nonprofitTabButtonFlag = false;
    } else if (this.searchTypeName == 'GRANT_SEARCH') {
      this.grant_page = pageChangeDto["page"];
      this.grant_pageSize = pageChangeDto["pageSize"];
      this.getAllSavedSearchTabPages(this.username, this.searchTypeName, this.grant_page, this.grant_pageSize);
      this.donorTabButtonFlag = false;
      this.grantTabButtonFlag = true;
      this.nonprofitTabButtonFlag = false;
    } else if (this.searchTypeName == 'NONPROFIT_SEARCH') {
      this.nonprofit_page = pageChangeDto["page"];
      this.nonprofit_pageSize = pageChangeDto["pageSize"];
      this.getAllSavedSearchTabPages(this.username, this.searchTypeName, this.nonprofit_page, this.nonprofit_pageSize);
      this.donorTabButtonFlag = false;
      this.grantTabButtonFlag = false;
      this.nonprofitTabButtonFlag = true;
    }
  }

  ngOnInit() {
    // @ts-ignore
    this.username = this.auth2ServiceChild.getUsername();
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
    this.donor_page = 1;
    this.grant_page = 1;
    this.nonprofit_page = 1;
    const pageChangeDto: PageChangeDto = {
      "page": 1,
      "pageSize": 5
    };
    this.decideLoad(pageChangeDto)
  }

  onCancel(): void {
    this.routerChild.navigateByUrl('app/users/dashboard');
  }

  onAddSavedSearches(): void {
    this.routerChild.navigateByUrl('app/users/dashboard/saved-searches/'+ this.saveSearchTypeRouteMap[this.searchTypeName] +'/create');
  }

  changePageResults(pageChangeDto: PageChangeDto): void {
    this.decideLoad(pageChangeDto);
  }

  openSearchTypeList(evt:any, searchTypeInput: string, searchTypeRoute: string): void {
    this.searchTypeName = searchTypeInput;
    this.searchTypeRoute = searchTypeRoute;
    // @ts-ignore
    const username: string = localStorage.getItem('username');
    const pageChangeDto: PageChangeDto = {
      "page": 1,
      "pageSize": 5
    };
    this.decideLoad(pageChangeDto);
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      // @ts-ignore
      tabcontent[i].style.display = "none";
    }
    /*
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }*/
    // @ts-ignore
    document.getElementById(searchTypeInput).style.display = "block";
  }
}
